var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropdownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5128 8.76559C7.07805 8.15996 8.02723 8.12723 8.63286 8.69249L12.1094 11.9372L15.5859 8.69249C16.1915 8.12723 17.1407 8.15996 17.706 8.76559C18.2712 9.37122 18.2385 10.3204 17.6329 10.8857L13.1329 15.0857C12.5565 15.6235 11.6622 15.6235 11.0859 15.0857L6.5859 10.8857C5.98028 10.3204 5.94755 9.37122 6.5128 8.76559Z",
    fill: "#03283A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownArrow);
export default __webpack_public_path__ + "static/media/dropdown-arrow.5cd50c28175ca8fdec0894d4f2dd4086.svg";
export { ForwardRef as ReactComponent };